module.exports = __webpack_public_path__ + "img/wallpaper-2.e1d71d2b.png";